import MainLayout from 'Components/Layout/MainLayout';
import {Button, message, Space, Spin} from 'antd';
import React, {useRef} from 'react';
import Style from './index.module.scss';
import TableRender, {ProColumnsType, TableContext} from 'table-render';
import useTable from 'Utils/Hooks/useTable';
import {deleteWebSite, getWebSitePage, WebSiteList} from './service';
import useRequestFn from 'Utils/Hooks/useRequestFn';
import {errorMessage} from 'Utils/common';
import DeleteConfirm from 'Components/DeleteConfirm';
import useModalHandler from 'Utils/Hooks/useModalHandler';
import EditModal from './Components/EditModal';
import dayjs from 'dayjs';
import {PlusOutlined} from '@ant-design/icons';
import ColumnModal from './Components/ColumnModal';

export default function Index() {
    const {tableInit} = useTable(getWebSitePage, {});
    const tableRef = useRef<TableContext>(null);
    const editModal = useModalHandler({
        component: EditModal,
    });
    const columnModal = useModalHandler({
        component: ColumnModal,
        type: 'drawer',
    });

    function reload() {
        tableRef?.current?.refresh();
    }

    const toolBar = (
        <div className={Style.toolBar}>
            <Space>
                <Button
                    type="primary"
                    onClick={() =>
                        editModal.open({
                            onOk: () => {
                                editModal.close();
                                reload();
                            },
                        })
                    }
                    icon={<PlusOutlined />}>
                    新增
                </Button>
            </Space>
        </div>
    );

    const [deleteAction, {loading: deleteLoading}] =
        useRequestFn(deleteWebSite);

    async function onDelete(id: string) {
        try {
            await deleteAction(id);
            await reload();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    const columns: ProColumnsType<WebSiteList> = [
        {title: '序号', render: (_, _item, index) => index + 1, width: 80},
        {
            title: '网站名称',
            dataIndex: 'sitename',
        },
        {
            title: '网址',
            dataIndex: 'baseDomainUrl',
            render: value => (
                <a href={value} target="_blank">
                    {value}
                </a>
            ),
        },
        {
            title: '计划下次爬取时间',
            dataIndex: 'expireTime',
            width: 160,
            render: (createTime: string) =>
                dayjs(createTime).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
            title: '操作',
            fixed: 'right',
            dataIndex: 'id',
            width: 160,
            align: 'center',
            render: (id: string, data) => (
                <Space>
                    <Button
                        size="small"
                        type="link"
                        onClick={() => {
                            columnModal.open({
                                siteId: id,
                                onOk: () => {
                                    columnModal.close();
                                },
                            });
                        }}>
                        栏目管理
                    </Button>
                    <Button
                        size="small"
                        type="link"
                        onClick={() => {
                            editModal.open({
                                data,
                                onOk: () => {
                                    editModal.close();
                                    reload();
                                },
                            });
                        }}>
                        修改
                    </Button>
                    <DeleteConfirm onSuccess={() => onDelete(id)}>
                        <Button size="small" type="link">
                            删除
                        </Button>
                    </DeleteConfirm>
                </Space>
            ),
        },
    ];

    return (
        <MainLayout.SpaceWrapper padding>
            <Spin spinning={deleteLoading}>
                <TableRender
                    rowKey="id"
                    ref={tableRef}
                    columns={columns}
                    toolbarRender={toolBar}
                    scroll={{x: 'max-content'}}
                    {...tableInit()}
                />
            </Spin>

            {editModal.render()}
            {columnModal.render()}
        </MainLayout.SpaceWrapper>
    );
}
